import React from 'react';
import Layout from 'src/components/article.layout';
import AuthorisedSwaggerUI from 'src/components/liveapi/authorisedSwaggerUI';
import { GetStaticPaths, GetStaticProps } from 'next';
import {
  NavigationPage,
  getDocumentTree,
  DocumentationVersion,
} from 'src/lib/docs-api';

// This could/can use the [..slug] page, but by breaking it up like this, we reduce the download size for all the non-endpoint/non-swagger docs pages
// Should convert the swagger-ui to dynamic load

interface LiveApiPageProps {
  version: DocumentationVersion;
  documentList: NavigationPage[];
}

export default function Document({
  version,
  documentList,
}: LiveApiPageProps): any {
  return (
    <Layout
      version={version}
      title="Live API Browser"
      description="Try out the Domain API without writing any code"
      documentList={documentList}
    >
      <div>
        <h1>Live API Browser</h1>
        <AuthorisedSwaggerUI version={version} operation="" />
      </div>
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  const params = context.params || {};
  const versionProp = params?.version?.toString() as DocumentationVersion;
  return {
    props: {
      version: versionProp,
      documentList: getDocumentTree(versionProp, 'live'),
    },
  };
};

function getVersionPaths(version: DocumentationVersion) {
  return [
    {
      params: {
        version,
      },
    },
  ];
}

export const getStaticPaths: GetStaticPaths = async () => {
  const versions: DocumentationVersion[] = ['v1', 'v2', 'beta', 'latest'];
  const paths = ([] as any[]).concat(
    ...versions.map((version) => getVersionPaths(version)),
  );
  return {
    paths,
    fallback: false,
  };
};
